import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { RuLocale } from '../constants/locale/Ru.locale';

const resources = {
  ru: RuLocale,
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ru',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
